import React, { useEffect, useState } from "react";
import "../../styles/reports/usageReport.css";
import { getIcon } from "../../utils/iconUtils";
import { useNavigate } from "react-router-dom";
import chartIcon from "../../assets/icons/chart-icon.png";
import chartIdleIcon from "../../assets/icons/chart-idle.png";
import gridIcon from "../../assets/icons/grid-icon.png";
import gridIdleIcon from "../../assets/icons/grid-idle.png";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  Chart,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartValueAxis,
  ChartValueAxisItem
} from "@progress/kendo-react-charts";
import "hammerjs";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import ReportsDropdown from "./ReportsDropdown";
import { DateInput, DateRangePicker } from "@progress/kendo-react-dateinputs";
import fetchClient from "../../api/fetch";
import { format } from "date-fns";
import { getTranslation } from "../../common/translation";
import { useTranslation } from "react-i18next";

const UsageReport = ({
  currentUser,
  reportsUsageGridList,
  getReportsUsageGridList,
  reportsUsageGridListPage,
  exportUsageReportToExcel,
  setLoading
}) => {
  const { t } = useTranslation();
  const Navigate = useNavigate();

  // Filter dropdown data
  const filterChart = ["Total active days", "Days since last login"];

  // Dropdown initial payload
  const initialPayload = {
    roleId: [],
    regionId: [],
    marketId: [],
    brandId: [],
    branchId: []
  };

  const initialDateValue = {
    start: null,
    end: null
  };

  // useStates
  const [dropdownValue, setDropdownValue] = useState(
    getTranslation("Total active days", t)
  );
  const [usageView, setUsageView] = useState("chart");
  const [payload, setPayload] = useState(initialPayload);
  const [dropdownData, setDropdownData] = useState(initialPayload);
  const [usageDateValue, setUsageDateValue] = useState(initialDateValue);
  const [usageChartData, setUsageChartData] = useState([]);
  const [isChanged, setIsChanged] = useState(false);
  const [usageGridSetting, setUsageGridSetting] = useState({
    sort: [],
    filter: undefined,
    pageSizeValue: 10,
    page: {
      skip: 0,
      take: 10
    }
  });
  const [params, setParams] = useState({
    sort: "",
    filter: ""
  });

  useEffect(() => {
    if (usageView === "chart") {
      let params = "";
      for (const item in payload) {
        const tempData = dropdownData[item];
        const index = item.indexOf("Id");
        if (payload[item].length === 0 && tempData.length === 0) {
          continue;
        } else if (payload[item].length === 0 && tempData.length !== 0) {
          params += `${params ? "&" : ""}${item.slice(0, index)}=NA`;
        } else {
          const ids = payload[item].map((i) => i[item]).toString();
          params += `${params ? "&" : ""}${item.slice(0, index)}=${ids}`;
        }
      }
      if (usageDateValue.start) {
        params += `${params ? "&" : ""}startDate=${format(
          usageDateValue.start,
          "yyyy-MM-dd HH:mm:ss.SSS"
        )}`;
      }
      if (usageDateValue.end) {
        params += `${params ? "&" : ""}endDate=${format(
          usageDateValue.end,
          "yyyy-MM-dd HH:mm:ss.SSS"
        )}`;
      }
      setLoading(true);
      fetchClient()
        .get("/v1/reports/userLogins/graph?" + params)
        .then((res) => {
          setUsageChartData(res.data.data);
        })
        .catch((err) => console.log(err))
        .finally(() => setLoading(false));
    } else {
      getReportsUsageGridList(queryBuilder());
    }
  }, [isChanged, usageView, usageDateValue, usageGridSetting.page, params]);

  const queryBuilder = () => {
    let dropdownParams = "";
    for (const item in payload) {
      const tempData = dropdownData[item];
      const index = item.indexOf("Id");

      if (payload[item].length === 0 && tempData.length === 0) {
        continue;
      } else if (payload[item].length === 0 && tempData.length !== 0) {
        dropdownParams += `&${item.slice(0, index)}=NA`;
      } else {
        const ids = payload[item].map((i) => i[item]).toString();
        dropdownParams += `&${item.slice(0, index)}=${ids}`;
      }
    }
    if (usageDateValue.start) {
      dropdownParams += `&startDate=${format(
        usageDateValue.start,
        "yyyy-MM-dd HH:mm:ss.SSS"
      )}`;
    }
    if (usageDateValue.end) {
      dropdownParams += `&endDate=${format(
        usageDateValue.end,
        "yyyy-MM-dd HH:mm:ss.SSS"
      )}`;
    }
    return `?filters=[${params.filter}]${params.sort}&page=${JSON.stringify(
      usageGridSetting.page
    )}${dropdownParams}`;
  };

  const filterBuilder = () => {
    let dropdownParams = "";
    for (const item in payload) {
      const tempData = dropdownData[item];
      const index = item.indexOf("Id");
      if (payload[item].length === 0 && tempData.length === 0) {
        continue;
      } else if (payload[item].length === 0 && tempData.length !== 0) {
        dropdownParams += `&${item.slice(0, index)}=NA`;
      } else {
        const ids = payload[item].map((i) => i[item]).toString();
        dropdownParams += `&${item.slice(0, index)}=${ids}`;
      }
    }
    if (usageDateValue.start) {
      dropdownParams += `&startDate=${format(
        usageDateValue.start,
        "yyyy-MM-dd HH:mm:ss.SSS"
      )}`;
    }
    if (usageDateValue.end) {
      dropdownParams += `&endDate=${format(
        usageDateValue.end,
        "yyyy-MM-dd HH:mm:ss.SSS"
      )}`;
    }
    return `&filters=[${params.filter}]&${params.sort}${dropdownParams}`;
  };

  //Grid pageChange
  const pageChange = (e) => {
    const targetEvent = e.targetEvent;
    const take = e.page.take;
    if (targetEvent.value) {
      setUsageGridSetting({
        ...usageGridSetting,
        pageSizeValue: targetEvent.value
      });
    }
    setUsageGridSetting((prevState) => ({
      ...prevState,
      page: {
        ...prevState.page,
        skip: e.page.skip,
        take
      }
    }));
  };

  const handleBack = () => {
    Navigate("/reports");
  };

  const dropdownHandleChange = (e) => {
    setDropdownValue(e.target.value);
  };

  const handleOpenUsageDropdown = (name, route) => {
    const userId = currentUser.userInfo.userId;
    let tempData = "";
    let params = "";
    for (const item in payload) {
      tempData = dropdownData[item];
      if (
        (payload[item].length === 0 && tempData.length === 0) ||
        item === "roleId"
      ) {
        continue;
      } else if (payload[item].length === 0 && tempData.length !== 0) {
        params += `${params ? "&" : ""}${item}=NA`;
      } else {
        const ids = payload[item].map((i) => i[item]).toString();
        params += `${params ? "&" : ""}${item}=${ids}`;
      }
    }
    const index = name.indexOf("Id");
    fetchClient()
      .get(
        name === "roleId"
          ? `/v1/users/${userId}/roles?isReport=true`
          : `/v1/users/${userId}/${route}?` + params
      )
      .then((res) => {
        tempData = dropdownData[name];
        setDropdownData({
          ...dropdownData,
          [name]:
            res.data.length > 0
              ? [
                  {
                    id: 0,
                    [name.slice(0, index) + "Description"]: "All"
                  }
                ].concat(res.data)
              : []
        });
        if (tempData.length === payload[name].length) {
          setPayload({ ...payload, [name]: res.data });
        }
      })
      .catch((err) => console.log(err))
      .finally();
  };

  const handleUsageDropdownChange = (e) => {
    // setPayload({ ...payload, [e.target.name]: e.target.value });
    setIsChanged(!isChanged);
    switch (e.target.name) {
      case "roleId":
      case "regionId":
      case "marketId":
      case "brandId":
      case "branchId":
        // check if selectAll option is included in the multiselect values
        const selectAll = e.target.value.some((item) => item.id === 0);
        // get name of array without "Id"
        const index = e.target.name.indexOf("Id");
        if (selectAll) {
          // if payload array is equal to the available options minus one,
          // meaning all of the options are selected
          if (
            payload[e.target.name].length ===
            dropdownData[e.target.name].length - 1
          ) {
            // deselect all if select all option is clicked again
            setPayload({ ...payload, [e.target.name]: [] });
          } else {
            // select all options but remove the "select all" object
            setPayload({
              ...payload,
              [e.target.name]: dropdownData[e.target.name].filter(
                (item) =>
                  item[`${e.target.name.slice(0, index)}Description`] !== "All"
              )
            });
          }
        } else {
          // if not all options are selected, only store the checked ones
          setPayload({ ...payload, [e.target.name]: e.target.value });
        }
        break;
      default:
        setPayload({ ...payload, [e.target.name]: e.target.value });
        break;
    }
  };

  const handleDate = (e) => {
    setUsageDateValue(e.target.value);
  };

  const handleSort = (e) => {
    setUsageGridSetting({
      ...usageGridSetting,
      sort: e.sort
    });
    if (e.sort.length > 0) {
      let obj = { ...e.sort[0] };
      obj["direction"] = obj["dir"];
      delete obj["dir"];
      obj = JSON.stringify(obj);
      setParams({ ...params, sort: `&sort=${obj}` });
    } else {
      setParams({ ...params, sort: "" });
    }
  };

  const handleFilterChange = (e) => {
    setUsageGridSetting({ ...usageGridSetting, filter: e.dataState.filter });
    if (e.dataState.filter !== undefined) {
      setParams({
        ...params,
        filter: e.dataState.filter.filters.map((item) => {
          let obj = { ...item };
          obj["condition"] = obj["operator"];
          delete obj["operator"];
          obj = JSON.stringify(obj);
          return obj;
        })
      });
      setUsageGridSetting((prevState) => ({
        ...prevState,
        page: { ...prevState.page, skip: 0 }
      }));
    } else {
      setParams({ ...params, filter: "" });
    }
  };

  const customStartDateInput = (props) => {
    return (
      <label>
        <DateInput {...props} label={getTranslation("Start", t)} />
      </label>
    );
  };

  const customEndDateInput = (props) => {
    return (
      <label>
        <DateInput {...props} label={getTranslation("End", t)} />
      </label>
    );
  };

  const handleExportUsageReport = async () => {
    try {
      exportUsageReportToExcel(filterBuilder());
    } catch (error) {
      console.error("Export error:", error);
    }
  };

  return (
    <div className="usage-report">
      <div className="d-flex gap-5 align-items-center mb-4 header">
        <img
          onClick={handleBack}
          src={getIcon("arrow-back.svg")}
          alt="back icon"
        />
        <p className="h1">{getTranslation("Usage report", t)}</p>
      </div>
      <div className="usage-report-cont w-100">
        <div className="usage-report-header">
          <button
            onClick={() => {
              setUsageView("chart");
              setPayload(initialPayload);
              setUsageDateValue(initialDateValue);
              setDropdownData(initialPayload);
            }}
            className={`${usageView === "chart" ? "primary-btn" : "btn-idle"}`}
          >
            {usageView === "chart" ? (
              <img src={chartIcon} alt="chart icon" />
            ) : (
              <img src={chartIdleIcon} alt="chart idle icon" />
            )}
          </button>
          <button
            onClick={() => {
              setUsageView("grid");
              setPayload(initialPayload);
              setDropdownData(initialPayload);
              setUsageDateValue(initialDateValue);
            }}
            className={`${usageView === "grid" ? "primary-btn" : "btn-idle"}`}
          >
            {usageView === "grid" ? (
              <img src={gridIcon} alt="chart icon" />
            ) : (
              <img src={gridIdleIcon} alt="chart idle icon" />
            )}
          </button>
          <button className="primary-btn" onClick={handleExportUsageReport}>
            <span>{getTranslation("Export to excel", t)}</span>
          </button>
        </div>
        <div className="usage-grid-header">
          <div>
            <p>{getTranslation("Region", t)}</p>
            <ReportsDropdown
              name="regionId"
              dataItemKey="regionId"
              data={dropdownData.regionId}
              textfield="regionDescription"
              value={payload.regionId}
              handleOpen={() => handleOpenUsageDropdown("regionId", "regions")}
              handleChange={handleUsageDropdownChange}
            />
          </div>
          <div>
            <p>{getTranslation("Market", t)}</p>
            <ReportsDropdown
              name="marketId"
              dataItemKey="marketId"
              data={dropdownData.marketId}
              textfield="marketDescription"
              value={payload.marketId}
              handleOpen={() => handleOpenUsageDropdown("marketId", "markets")}
              handleChange={handleUsageDropdownChange}
            />
          </div>
          <div>
            <p>{getTranslation("Brand", t)}</p>
            <ReportsDropdown
              name="brandId"
              dataItemKey="brandId"
              data={dropdownData.brandId}
              textfield="brandDescription"
              value={payload.brandId}
              handleOpen={() => handleOpenUsageDropdown("brandId", "brands")}
              handleChange={handleUsageDropdownChange}
            />
          </div>
          <div>
            <p>{getTranslation("Branch", t)}</p>
            <ReportsDropdown
              name="branchId"
              dataItemKey="branchId"
              data={dropdownData.branchId}
              textfield="branchDescription"
              value={payload.branchId}
              handleOpen={() => handleOpenUsageDropdown("branchId", "branches")}
              handleChange={handleUsageDropdownChange}
            />
          </div>

          <div>
            <p>{getTranslation("Role", t)}</p>
            <ReportsDropdown
              name="roleId"
              dataItemKey="roleId"
              data={dropdownData.roleId}
              textfield="roleDescription"
              value={payload.roleId}
              handleOpen={() => handleOpenUsageDropdown("roleId", "roles")}
              handleChange={handleUsageDropdownChange}
            />
          </div>
          <div className="daterange-picker">
            <DateRangePicker
              format={"dd/MM/yyyy"}
              value={usageDateValue}
              onChange={handleDate}
              startDateInput={customStartDateInput}
              endDateInput={customEndDateInput}
            />
          </div>
        </div>
        {usageView === "chart" ? (
          <div className="usage-chart-box">
            <div className="usage-chart-cont">
              <div className="align-self-start">
                <DropDownList
                  data={filterChart}
                  value={dropdownValue}
                  onChange={dropdownHandleChange}
                />
              </div>
              <div className="usage-chart-holder align-self-center">
                <Chart>
                  <ChartLegend position="bottom" orientation="horizontal" />

                  <ChartValueAxis>
                    <ChartValueAxisItem
                      title={{
                        font: "Poppins Bold",
                        text: dropdownValue
                      }}
                    />
                  </ChartValueAxis>
                  <ChartSeries>
                    {usageChartData?.map((item, idx) => (
                      <ChartSeriesItem
                        key={idx}
                        type="column"
                        tooltip={{
                          visible: true
                        }}
                        color="#16BAE7"
                        data={
                          dropdownValue === "Total active days"
                            ? item.totalActiveDays
                            : item.daysSinceLastLogin
                        }
                        name={item.name}
                      />
                    ))}
                  </ChartSeries>
                </Chart>
              </div>
            </div>
          </div>
        ) : (
          <div className="usage-report-cont">
            <div className="usage-grid-cont">
              <Grid
                data={reportsUsageGridList?.map((item) => ({
                  ...item,
                  lastLoginDate: item.lastLoginDate
                    ? new Date(item.lastLoginDate)
                    : null
                }))}
                skip={usageGridSetting.page.skip}
                take={usageGridSetting.page.take}
                total={reportsUsageGridListPage?.totalRecords}
                filter={usageGridSetting.filter}
                sort={usageGridSetting.sort}
                filterable={true}
                sortable={true}
                onSortChange={handleSort}
                onDataStateChange={handleFilterChange}
                pageable={{
                  buttonCount:
                    reportsUsageGridListPage?.totalPages > 10
                      ? 10
                      : reportsUsageGridListPage?.totalPages,
                  info: true,
                  pageSizes: [5, 10, 20],
                  pageSizeValue: usageGridSetting.pageSizeValue
                }}
                onPageChange={pageChange}
              >
                <Column
                  field="userFullName"
                  title={getTranslation("Name", t)}
                  width="159px"
                />
                <Column
                  field="roleDescription"
                  title={getTranslation("Role", t)}
                  width="200px"
                />
                <Column
                  field="region"
                  title={getTranslation("Region", t)}
                  width="159px"
                />
                <Column
                  field="market"
                  title={`${getTranslation("Market", t)}(${getTranslation(
                    "Country",
                    t
                  )})`}
                  width="159px"
                />
                <Column
                  field="brand"
                  title={getTranslation("Brand", t)}
                  width="174px"
                />
                <Column
                  field="branch"
                  title={getTranslation("Branch", t)}
                  width="159px"
                />
                <Column
                  field="daysSinceLastLogin"
                  title={getTranslation("Days since last login", t)}
                  width="174px"
                />
                <Column
                  field="lastLoginDate"
                  title={getTranslation("Last login", t)}
                  width="200px"
                  filter="date"
                  format="{0:dd/MM/yyyy}"
                />
                <Column
                  field="totalActiveDays"
                  title={getTranslation("Total active days", t)}
                  width="174px"
                />
              </Grid>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UsageReport;
